module.exports = __webpack_public_path__ + "87def88434e6e673a2c7f86db4eb180d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/cauldron.png
// module id = 1819
// module chunks = 0